<template>
    <div class="invite_main">
        <div class="invite_header">
            <div class="icon">
                <div class="eng">广州劳动仲裁院</div>
                <div>GUANGZHOU LABOR ARBITRATION COURT</div>
            </div>
            <div class="title">广州劳动人事微仲裁</div>
        </div>
        <div class="invite_content">
            <div class="invite-login reset-login">
							<div class="reset-title">
                    <div class="title">为保障账户安全，请先修改登录密码</div>
                </div>
							<div class="rightItem">
									<el-input class="input" v-model="resetform.pwd" maxlength="16" @keyup.enter="golost"
														placeholder="输入新密码" autocomplete="off"
														show-password/>
									<div class='validateTip'>{{validatetip2.pwd}}</div>
							</div>
							<div class="rightItem">
									<el-input class="input" v-model="resetform.pwd2" maxlength="16" @keyup.enter="golost"
														placeholder="确认新密码" autocomplete="off"
														show-password/>
									<div class='validateTip'>{{validatetip2.pwd2}}</div>
							</div>
							<div class="rightItem">
									<el-button plain class="enter" @click="golost" :loading="resetLoad">
											确认修改
									</el-button>
							</div>
            </div>
        </div>
    </div>
</template>
<script>
import { updatePassword } from "@/api/login.js";
import {
  setStore,
  getStore,
  removeStore,
  setStoreSession,
  getStoreSession,
  getToken
} from "@/utils/utils.js";
import { setTimeout } from "timers";
export default {
  data() {
    return {
      stid: 0,
      resetform: {
        phonenum: "",
        pwd: "",
        pwd2: "",
        code: ""
      },
      validatetip2: {
        phonenum: "",
        pwd: "",
        pwd2: "",
        code: ""
      },
      codeDisabled: false,
      resetLoad: false,
      oldPassword: ""
    };
  },
  mounted() {
    this.oldPassword = this.$Base64.decode(localStorage.getItem("oldPassword"));
  },
  methods: {
    checkresetpwd() {
      let check = true;
      let passwordReg = /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,16}$/;
      if (!this.resetform.pwd.trim()) {
        this.validatetip2.pwd = "请输入密码";
        check = false;
      } else if (!passwordReg.test(this.resetform.pwd)) {
        this.validatetip2.pwd =
          "请输入8~16位数字和大小写字母及特殊字符组合的密码";
        check = false;
      }

      if (!this.resetform.pwd2.trim()) {
        this.validatetip2.pwd2 = "请再次输入密码";
        check = false;
      } else if (this.resetform.pwd != this.resetform.pwd2) {
        this.validatetip2.pwd2 = "两次密码不匹配，请重新输入";
        check = false;
      }

      if (check) {
        this.validatetip2.pwd = "";
        this.validatetip2.pwd2 = "";
      }
      return check;
    },
    // 修改密码
    golost() {
      let dologin = true;
      if (!this.checkresetpwd()) {
        dologin = false;
      }
      if (!dologin) {
        return;
      }
      this.resetLoad = true;
      let parms = {
        oldPassword: this.oldPassword,
        newPassword: this.resetform.pwd2
      };
      updatePassword(parms).then(
        res => {
          console.log(res);
          let _this = this;
          if (res.data.code === 1000) {
            this.$message({
              message: "密码重置成功, 3秒后返回登录",
              type: "success"
            });
            setTimeout(() => {
              _this.$router.push({ path: "/loginWorker" });
              _this.resetLoad = false;
            }, 3000);
          } else {
            this.resetLoad = false;
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        },
        err => {
          this.resetLoad = false;
        }
      );
    }
  },
  components: {}
};
</script>
<style lang="scss">
.invite_main {
  height: 100%;
  width: 100%;
  background: url("../../assets/bg.png") no-repeat center top;
  background-size: 100% 100%;
  .invite_header {
    display: flex;
    align-items: center;
    height: 110px;
    width: 85.5%;
    margin: 0 auto;
    color: #fff;
    .icon {
      position: relative;
      margin-right: 40px;
      .eng {
        font-size: 14px;
        letter-spacing: 25px;
      }
    }
    .icon:before {
      content: "";
      position: absolute;
      display: block;
      right: -10px;
      top: 10px;
      width: 1px;
      height: 0;
      border-top: 20px solid #ffffff;
    }
    .title {
      font-size: 28px;
      letter-spacing: 12px;
    }
  }
  .invite_content {
    position: relative;
    height: 80%;
    width: 85.5%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url("../../assets/bg_content.png") no-repeat center top;
    background-size: 100% 100%;
    .invite-login {
      position: absolute;
      right: 83px;
      height: 500px;
      padding: 0 50px;
      background-color: #fff;
      border-radius: 4px;
      .reset-title {
        // text-align: center;
        margin-bottom: 30px;
        .title {
          padding-top: 30px;
          font-size: 18px;
          letter-spacing: 5px;
        }
      }
      .rightItem {
        margin-top: 30px;
        .validateTip {
          position: absolute;
          left: 50px;
          margin-top: 4px;
          color: red;
          line-height: 15px;
        }
        .normalBtn {
          border-radius: 0px;
          background-image: linear-gradient(90deg, #0083c8 0%, #142f9e 100%),
            linear-gradient(#0d44b0, #0d44b0);
          background-blend-mode: normal, normal;
          box-shadow: 0px 8px 18px 0px rgba(0, 59, 185, 0.3);
          background-blend-mode: normal, normal;
          color: #fff;
          cursor: pointer;
        }
        .enter {
          margin: 50px auto;
          width: 300px;
          height: 46px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-image: linear-gradient(90deg, #0083c8 0%, #142f9e 100%),
            linear-gradient(#0d44b0, #0d44b0);
          background-blend-mode: normal, normal;
          box-shadow: 0px 8px 18px 0px rgba(0, 59, 185, 0.3);
          background-blend-mode: normal, normal;
          font-size: 18px;
          color: #fff;
          cursor: pointer;
        }
        .el-input__inner {
          border: 0;
          padding: 0;
          border-bottom: 1px solid #dcdfe6;
          border-radius: 0;
        }
      }
    }
    .reset-login {
      height: 350px;
    }
  }
}
</style>